export const getEntryStatusColor = (status) => {
  switch (status) {
    case "NEW":
      return "#2196F3";
    case "PENDING_PAYMENT":
      return "#FFC107";
    case "SUBMITTED":
      return "#42A5F5";
    case "REJECTED":
      return "#d90429";
    case "PROCESSING":
      return "#FB8C00";
    case "CORRECTION":
      return "#FFB300";
    case "ADDITIONAL_CORRECTION":
      return "#FFA726";
    case "FOR_APPROVAL":
      return "#7B1FA2";
    case "INSTITUTIONS_REVIEW":
      return "#8E24AA";
    case "INSTITUTION_DECISION":
      return "#5E35B1";
    case "FINAL_DECISION_SIGNING":
      return "#F4511E";
    case "DONE":
      return "#4CAF50";
    case "CANCELED":
      return "#9E9E9E";
    default:
      return "#90A4AE";
  }
};
